module.exports = require('striptags')
